<template>
  <div>
    <div class="top"> 
      <div class="flex logo">
        <img src="@/assets/images/lzwd.png" style="width: 28px;height: 28px;margin-left: 25px;margin-top: 15px"/>
        <div class="title font-bold pointer" @click="home">量子文档</div> 
      </div> 
      <div class="flex flex-end flex-center-cz ">
        <div v-if="false" class="margin-right-m blue-btn-a flex flex-center-cz flex-center-sp pointer" @click="getMember"><img class="huiyuan-ico" src="@/assets/images/libao.png"/><div>领取会员</div></div>
        <div v-if="false" class="margin-right-xl blue-btn-a flex flex-center-cz flex-center-sp pointer" @click="beMember"><img class="huiyuan-ico" src="@/assets/images/huiyuan.png"/><div>升级高级版</div></div>
        <div v-if="false" class="margin-right-xl margin-top-s pointer" @click="app"><img class="app-ico" src="@/assets/images/app.png"/></div>
        <div class="margin-right-xl margin-top-s pointer" @click="dateClick"><img class="date-ico" src="@/assets/images/rili.png"/></div>  
        <div class="margin-right-xl margin-top-s pointer" @click="todoClick"><img class="todo-ico" src="@/assets/images/todo.png"/></div>      
        <div class="margin-right-xl margin-top-s pointer" @click="noteClick"><img class="note-ico" src="@/assets/images/note.png"/></div>

        <div class="margin-right-xl margin-top-s pointer xiaoxi-btn" @click="msgInfoClick">
          <img class="xiaoxi-ico" src="@/assets/images/xiaoxi.png"/>
          <div v-if="msgCount>0" class="xiaoxi-count">{{msgCount}}</div>
        </div>
        <div class="margin-right-xl margin-top-s pointer" @click="userInfoClick">
          <img v-if="token != null && token != '' && token != 'null'" class="user-ico" src="@/assets/images/user.png"/>
          <img v-if="token == null || token == '' || token == 'null'" class="user-ico" src="@/assets/images/wzuser.png"/>
        </div>
      </div>
        
    </div>
    <div class="left">
      <div class="menu">
        <div class="item pointer" :class="{'activeMenu' : activeMenu=='person'}"  @click="menuClick('person')"><img class="huiyuan-ico" src="@/assets/images/kongjian2.png"/><div>个人空间</div></div>
        <div class="item pointer" :class="{'activeMenu' : activeMenu=='history'}"  @click="menuClick('history')"><img class="huiyuan-ico" src="@/assets/images/history2.png"/><div>最近浏览</div></div>
        <div class="item pointer" :class="{'activeMenu' : activeMenu=='collect'}"  @click="menuClick('collect')"><img class="huiyuan-ico" src="@/assets/images/like2.png"/><div>我的收藏</div></div>
        <div class="item pointer" :class="{'activeMenu' : activeMenu=='recovery'}"  @click="menuClick('recovery')"><img class="huiyuan-ico" src="@/assets/images/hsz2.png"/><div>收回站</div></div>
      </div>
    </div>
    <div class="content">
      <router-view @childOpen="childOpen"></router-view>  
    </div> 

    <user-info :show="showUser" @close="showUser = false"></user-info>
    <msg-info :show="showMsg" @close="showMsg = false" @change="msgChange"></msg-info>
    <Note :show="showNote" @close="showNote = false" ></Note>
    <Todo :show="showTodo" @close="showTodo = false" ></Todo>
    <Calendar :show="showCalendar" @close="showCalendar = false" ></Calendar>
  </div>

</template>


<script>
/*
       名称：vue纯前端Demo下载网站源码
       功能：完成前端的各种交互，如数据绑定，列表显示，点击事件，页面跳转，页面间传参，数据处理，图片显示
       作者：唐赢   
       时间：2022-11-30
*/

import UserInfo from '@/modules/userInfo/UserInfo.vue'
import MsgInfo from '@/modules/msgInfo/MsgInfo.vue'
import Note from '@/modules/note/Note.vue'
import Todo from '@/modules/todo/Todo.vue'
import {noReadMsgCount} from '@/api/api.js';
import Calendar from '../modules/calendar/Calendar.vue'

export default {
  name: 'Home',
  components: {
      UserInfo,MsgInfo,Note,Todo,Calendar
  },
  data() {
    return {
      msgCount:0,
      showUser : false,
      showMsg : false,
      showNote: false,
      showTodo: false,
      showCalendar: false,
      token: sessionStorage.getItem("token"),
      activeMenu: 'person'

    }
  },
  created() {
    this.getMsg();

  },
  methods:  {
    getMsg(){
      noReadMsgCount().then((res) => {
        console.log("noReadMsgCount=====", res)
        this.msgCount = res.data.result;
      }) 

    } ,
    msgChange() {
      this.getMsg();

    },
    stopPropa(event) {
      event || (event = window.event);
        event.stopPropagation ? event.stopPropagation(): (event.cancelBubble = true);
    },
    userInfoClick(event) {
      this.stopPropa(event);
      document.addEventListener("click", this.closeUserInfo, false);// 监听关闭事件
      this.showUser = !this.showUser ;
      this.showMsg = false;      
    },
    getMember() {
      this.$router.push({
          path: '/invite',
      }) 
    },
    beMember() {
      this.$router.push({
          path: '/beMember',
      }) 
    },
    msgMenuClick(args) {
      let id = args[0];
      alert("您点击了：" + id);
    },  
    closeUserInfo() {
      document.removeEventListener("click", this.closeUserInfo, false);
      this.showUser  = false;// 隐藏弹窗
      this.showMsg  = false;// 隐藏弹窗
      this.showNote = false;
    },
    msgInfoClick(event) {
      this.stopPropa(event);
      this.getMsg();
      document.addEventListener("click", this.closeUserInfo, false);// 监听关闭事件
      this.showUser = false;// 隐藏弹窗
      this.showMsg = !this.showMsg ;
    },
    childOpen(url) {
      console.log("来自子页面的url====", url)
      if (url == "/recovery") {
        this.activeMenu = "recovery"
      }
      else if (url == "/history") {
        this.activeMenu = "history"
      }
      else if (url == "/person") {
        this.activeMenu = "person"
      }
      else if (url == "/collect") {
        this.activeMenu = "collect"
      }
    },
    menuClick(id) {

      this.activeMenu = id;
      this.$router.push({
          path: '/' + id ,
      }) 
      
    },
    dateClick() {
      this.showCalendar = true;
    },
    noteClick() {
      this.stopPropa(event);
      //document.addEventListener("click", this.closeUserInfo, false);// 监听关闭事件
      this.showNote = !this.showNote;
      this.showUser  = false;// 隐藏弹窗
      this.showMsg  = false;// 隐藏弹窗

    },
    todoClick() {
      this.showTodo = true;

    },
    home() {
      this.$router.push({
          path: '/',
      }) 
    },
    app() {
      this.$router.push({
          path: '/down',
      }) 
    },
    exit(){
      this.$router.push({
          path: '/login',
      }) 

    }
  }


}
</script>

<style scoped>

  .top {
    position: absolute;
    display: flex;
    justify-content: space-between;
    top: 0;
    left: 0;
    right: 0;
    height: 45px;
    background-color: #fff;
    box-shadow: 0 1px 0 0 rgb(0 0 0 / 3%);
    z-index: 100;
  }
  .left{
    position: absolute;
    top: 45px;
    width: 235px;
    background-color: #f0f3f8;
    z-index: 101;
    bottom: 0;
    left:0;
    border-right: 1px solid;
    border-color: rgba(0, 0, 0, .1);
  }
  .menu{
    color: #000;
    padding: 15px;
    display: flex;
    flex-direction: column;   
  }
  .item {
    padding-left: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    border-radius: 5px;

  }
  .item:hover {
    background-color: #ccdff8;
    border-top: 1px solid #f0f3f8;
    border-bottom: 1px solid #f0f3f8;
    height: 38px;
  }

  .activeMenu {
    background-color: #ccdff8;
  }

  .content {
    position: fixed;
    left: 236px;
    top: 46px;
    right: 0px;
    bottom: 0px;
    z-index: 888;
    overflow: auto;
  }
  .logo {

    width: 235px;
    font-size: 20px;
    line-height: 45px;
    background-color: #f0f3f8;
    vertical-align: top;
    white-space: nowrap;
    border-right: 1px solid;
    border-color: rgba(0, 0, 0, .1);
  }
  .title {
    margin-top:8px;
    margin-left: 12px;

  }

  .blue-btn-a {
    border-radius: 15px;
    font-size: 14px;
    width: 110px;
    height: 32px;
    background-color: #f2f8ff;
    color: #0070f9;
  }

  .blue-btn-a:hover {
    opacity: 1.2; 
  }


  .huiyuan-ico {
    margin-right: 5px;
    width: 20px;
    height: 20px;
  }

  .xiaoxi-ico {
    margin-top: 2px;
    width: 25px;
    height: 25px;
  }

  .xiaoxi1-ico {
    margin-top: 3px;
    margin-left: 8px;
    width: 22px;
    height: 22px;
  }

  .app-ico {
    margin-top: 2px;
    width: 20px;
    height: 20px;
  }

  .xiaoxi-btn {
    position: relative;
  }

  .xiaoxi-count {
    position: absolute;
    color: white;
    font-size: 8px;
    background-color: red;
    min-width: 16px;
    max-width: 25px;
    height: 16px;
    line-height: 16px;
    left: 55%;
    top: -4px;
    text-align: center;
    -webkit-border-radius: 24px;
    border-radius: 24px;
  }



  .user-ico {
    margin-top: 2px;
    width: 32px;
    height: 32px;
  }

  .note-ico {
    margin-top: 2px;
    width: 22px;
    height: 22px;
  }

  .date-ico {
    margin-top: 2px;
    width: 23px;
    height: 26px;
  }
  

  .todo-ico {
    margin-top: 2px;
    width: 23px;
    height: 23px;
  }
  


</style>


// WEBPACK FOOTER //
// src/views/Main.vue